import React from 'react';
import { Modal } from 'react-bootstrap';

export const CompleteMessage: React.FC = () => (
    <Modal.Body>
        <p>Document uploaded successfully. You can now request CPD for this document.</p>
    </Modal.Body>
);
